import React from 'react';
import { Box } from '@mui/material';
import AgentMarkdown from './AgentMarkdown';

interface Props {
  role: 'user' | 'assistant' | 'error';
  text: string;
}

export default function AgentMessage({ role, text }: Props) {
  const isUser = role === 'user';
  const isError = role === 'error';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isUser ? 'flex-end' : 'flex-start',
        px: 1.5,
        my: 0.6,
      }}
    >
      <Box
        sx={{
          maxWidth: '85%',
          px: 1.4,
          py: 0.8,
          borderRadius: 2,
          background: isError ? '#fef2f2' : isUser ? '#0ea5e9' : '#f1f5f9',
          color: isError ? '#991b1b' : isUser ? '#fff' : '#0f172a',
          border: isError ? '1px solid #fecaca' : 'none',
          fontSize: 13,
          wordBreak: 'break-word',
        }}
      >
        {isUser ? (
          <Box sx={{ fontSize: 13, lineHeight: 1.55, whiteSpace: 'pre-wrap' }}>{text}</Box>
        ) : (
          <Box sx={{ fontSize: 13 }}>
            <AgentMarkdown text={text} />
          </Box>
        )}
      </Box>
    </Box>
  );
}
